import React, { useState } from "react";
import { Box, Fab, useScrollTrigger } from "@material-ui/core";
import {
  Phone as PhoneIcon,
  Clear as CloseIcon
} from "@material-ui/icons";
import PublishIcon from '@material-ui/icons/Publish';

import PhoneBoxInfo from "../PhoneBoxInfo";

import { useStyles, useOpenBoxPhoneInfo } from "../../hooks";
import styles from "./styles";

const FloatingPhoneButton = ({ home = false, isNotes = false }) => {
  const classes = useStyles(styles);
  const scrollTrigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100
  });

  const  [open, setOpen] = useState(false);

  return (
      <Box className={classes.root}>
        {open && <PhoneBoxInfo />}
          <Fab color="secondary" onClick={() => setOpen(!open)} elevation={0}>
            {open ? (
              <CloseIcon fontSize="large" />
            ) : (
              <PhoneIcon fontSize="large" />
            )}
          </Fab>
      </Box>
  );
};

export default FloatingPhoneButton;
